module.exports = __webpack_public_path__ + "static/media/vission.fab5115f.JPG";